module.exports = __webpack_public_path__ + "img/img_cs_img2.a8752b3c.png";